<div class="indicator-container">
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M3 3.5V2.5H7.5V3.5H3ZM3 5V4H7.5V5H3ZM4.5 10H1.5C1.08333 10 0.729167 9.85417 0.4375 9.5625C0.145833 9.27083 0 8.91667 0 8.5V7H1.5V0H9V4.5125C8.83333 4.49583 8.66458 4.50208 8.49375 4.53125C8.32292 4.56042 8.15833 4.6125 8 4.6875V1H2.5V7H5.5L4.5 8H1V8.5C1 8.64167 1.04792 8.76042 1.14375 8.85625C1.23958 8.95208 1.35833 9 1.5 9H4.5V10ZM5.5 10V8.4625L8.2625 5.7125C8.3375 5.6375 8.42083 5.58333 8.5125 5.55C8.60417 5.51667 8.69583 5.5 8.7875 5.5C8.8875 5.5 8.98333 5.51875 9.075 5.55625C9.16667 5.59375 9.25 5.65 9.325 5.725L9.7875 6.1875C9.85417 6.2625 9.90625 6.34583 9.94375 6.4375C9.98125 6.52917 10 6.62083 10 6.7125C10 6.80417 9.98333 6.89792 9.95 6.99375C9.91667 7.08958 9.8625 7.175 9.7875 7.25L7.0375 10H5.5ZM6.25 9.25H6.725L8.2375 7.725L8.0125 7.4875L7.775 7.2625L6.25 8.775V9.25ZM8.0125 7.4875L7.775 7.2625L8.2375 7.725L8.0125 7.4875Z"
      class="indicator-path"
    />
  </svg>
</div>
